import React from "react";
import { Modal, Form, Select, Input, message } from "antd";
import request from "../../../utils/request";
import { ProjectItem, useGlobal } from "../../../contexts/GlobalContext";

interface KnowledgeWebModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  projects: ProjectItem[];
}

const KnowledgeWebModal: React.FC<KnowledgeWebModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  projects,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const { API_BASE_URL, token, user } = useGlobal();

  React.useEffect(() => {
    // 设置默认项目为第一个 PostChat 项目
    if (visible && projects.length > 0) {
      const postChatProjects = projects.filter(project => project.is_postchat);
      if (postChatProjects.length > 0) {
        form.setFieldsValue({ project_id: postChatProjects[0].id });
      }
    }
  }, [visible, projects, form]);

  const handleOk = async () => {
    try {
      // 检查用户是否是 PostChat 会员
      if (!user?.apiInfo?.postchat?.vip_info?.is_vip) {
        message.error("此功能为全功能项目（Pro 及以上）能力");
        return;
      }

      setLoading(true);
      const values = await form.validateFields();

      try {
        const response = await request.post(
          `${API_BASE_URL}/api/v3/knowledge/download`,
          {
            project_id: values.project_id,
            title: values.url, // 使用 URL 作为标题
            url: values.url,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.code === 200) {
          message.success("添加成功");
          onCancel();
          form.resetFields();
          onSuccess();
        } else {
          message.error(response.data.msg || "添加失败");
        }
      } catch (error) {
        message.error("获取网页内容失败，请确保网页地址可访问");
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error("表单验证失败:", error);
      setLoading(false);
    }
  };

  return (
    <Modal
      title="从网页添加"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="确认添加"
      cancelText="取消"
      confirmLoading={loading}
      width={800}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" style={{ paddingRight: "10px" }}>
        <Form.Item
          name="project_id"
          label="选择项目"
          rules={[{ required: true, message: "请选择项目" }]}
          extra="仅支持 PostChat 类型的项目"
        >
          <Select placeholder="请选择项目">
            {projects.filter(project => project.is_postchat).map((project) => (
              <Select.Option key={project.id} value={project.id}>
                {project.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="url"
          label="网页地址"
          rules={[
            { required: true, message: "请输入网页地址" },
            { type: "url", message: "请输入有效的网页地址" },
          ]}
        >
          <Input placeholder="请输入网页地址，例如：https://www.example.com" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default KnowledgeWebModal;
